import React from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

const KitHireChargeWarningModal = ({ isOpen, onYes, onNo }) => {
	return (
		<Modal centered isOpen={isOpen} toggle={onNo} backdrop="static">
			{/* <ModalHeader toggle={onNo}>Hire Charge</ModalHeader> */}
            <ModalHeader toggle={onNo}>
                <span style={{ color: "Red", fontWeight: "bold" }}>Hire Charge Warning</span>
            </ModalHeader>
			<ModalBody>
				Are you sure you don't want to waive a hire charge?
			</ModalBody>
			<ModalFooter>
				<button className="btn btn-secondary" onClick={onNo}>
					No
				</button>
				<button className="btn btn-primary" onClick={onYes}>
					Yes
				</button>
			</ModalFooter>
		</Modal>
	);
};

export default KitHireChargeWarningModal;